
  // ------- setting height for background aos - start
  let allIngredientsSection = document.querySelectorAll('.custom-ingredient-container')
  let totalSections = allIngredientsSection.length
  let firstIngreSec = allIngredientsSection[0]
  let lastIngreSec = allIngredientsSection[totalSections - 1]

  let topOfFirstSec = firstIngreSec.getBoundingClientRect().top
  let bottomOfLastSec = lastIngreSec.getBoundingClientRect().bottom

  let totalHeightByIngreSections = bottomOfLastSec - topOfFirstSec


  let aniamtionSec = document.querySelector('.custom-backgroud-animamtion-sec')
  aniamtionSec.style.height = `${totalHeightByIngreSections}px`
  // ------- setting height for background aos - end
